export enum ReeferZoneOperatingModeCategory {
    Unknown = -1,
    PowerOff = 0,
    Heating = 1,
    Cooling = 2,
    Idle = 3,
    Defrost = 4,
    Pretrip = 5,
    Sleep = 6
}
